import { z } from 'zod';
import * as e from "./EAppValidation"

export interface IAppValidationNewRequest {
  appDefinitionId: string;
  appEnvironmentId: string | null;
}

export const AppValidationNewRequestSuccess = z.object({
  appValidationId: z.string().nullish(),
  status: z.nativeEnum(e.ValidationStatus),
});

export type IAppValidationNewRequestSuccess = z.infer<typeof AppValidationNewRequestSuccess>;
